<template>
    <TinymceEditor v-if="type === 'html'" v-bind="$attrs" :init="init" v-on="$listeners" />
    <TinymceEditor v-else-if="type === 'html_legacy'" v-bind="$attrs" :init="init" v-on="$listeners" />
    <TinymceEditor v-else-if="type === 'html_template'" v-bind="$attrs" :init="templateEditorInit" v-on="$listeners" />
    <zitat-block-field v-else-if="type === 'zitat'" v-bind="$attrs" :init="init" v-on="$listeners" />
    <div v-else>Unsupported Content Block: {{ type }}</div>
</template>

<script>
import ZitatBlockField from '@/components/form/zitat-block-field.vue';
/**
 * Wraps a content block field to its corresponding
 * form input field (e.g. a tinymce editor field for 'html' fields)
 *
 * Depending on the given type, the correct field is rendered.
 *
 * All additional props / listeners are passed to the child component.
 */
export default {
    name: 'ContentBlockField',
    components: { ZitatBlockField },
    props: {
        type: {
            type: String,
            required: true,
        },
        init: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },

    computed: {
        templateEditorInit() {
            let tplEditInit = {
                toolbar1:
                    'template | bold italic underline strikethrough | cut copy paste pasteword | bullist numlist | subscript superscript |  undo redo | link unlink anchor image',
                toolbar2: '',
            };
            return Object.assign(tplEditInit, this.init);
        },
    },
};
</script>
